<script lang="ts">const thinkingMessages = [
    'Searching for the best answer',
    'Analyzing your request',
    'Finding relevant information',
    'Processing your question',
    'Checking our knowledge base',
    'Researching solutions',
    'Consulting our database',
    'Preparing recommendations',
    'Finding the perfect match',
    'Exploring options for you',
    'Digging through our resources',
    'Putting together an answer',
    'Assembling helpful details',
    'Working on it',
];
const selectedMessage = thinkingMessages[Math.floor(Math.random() * thinkingMessages.length)];
</script>

<div class="typing-indicator">
  <div class="typing-message">
    <div class="typing-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M8.72727 0C8.72727 2.71772 9.3895 4.48999 10.5369 5.59446C11.6899 6.70412 13.47 7.27273 16 7.27273V8.72727C13.47 8.72727 11.6899 9.29588 10.5369 10.4055C9.3895 11.51 8.72727 13.2823 8.72727 16H7.27273C7.27273 13.47 6.70412 11.6899 5.59446 10.5369C4.48999 9.3895 2.71772 8.72727 0 8.72727V7.27273C2.71772 7.27273 4.48999 6.6105 5.59446 5.46307C6.70412 4.31011 7.27273 2.53005 7.27273 0H8.72727Z"
          fill="black"
          fill-opacity="0.9"
        />
      </svg>
    </div>
    <div class="typing-text">
      {selectedMessage}
    </div>
  </div>
  <div class="loading-blocks">
    <div class="loading-block"></div>
    <div class="loading-block"></div>
    <div class="loading-block"></div>
    <div class="loading-block"></div>
    <div class="loading-block"></div>
  </div>
</div>

<style>.typing-indicator {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  background: #ffffff;
  border-radius: 18px 18px 18px 4px;
  box-shadow: none;
  max-width: 95%;
  animation: fadeIn 0.3s ease-in-out;
}

.typing-message {
  display: flex;
  gap: 10px;
  align-items: center;
}

.typing-icon {
  flex-shrink: 0;
}
.typing-icon svg {
  animation: spin 2s linear infinite;
}

.typing-text {
  font-size: 14px;
  color: #333333;
}

.loading-blocks {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
}

.loading-block {
  height: 12px;
  background: #e0e0e0;
  border-radius: 6px;
  animation: pulse 1.5s ease-in-out infinite;
}
.loading-block:nth-child(1) {
  width: 100%;
  animation-delay: 0s;
}
.loading-block:nth-child(2) {
  width: 100%;
  animation-delay: 0.1s;
}
.loading-block:nth-child(3) {
  width: 100%;
  animation-delay: 0.2s;
}
.loading-block:nth-child(4) {
  width: 100%;
  animation-delay: 0.3s;
}
.loading-block:nth-child(5) {
  width: 60%;
  animation-delay: 0.4s;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.8;
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}</style>
